import { ProposalBlock } from '@vzmi/shp_shared_compo'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'

import styles from './index.css'
import BrandIDInfo from './BrandIDInfo'

const UpdateBrandID = props => {
  const {
    flags,
    change,
    readOnly,
    proposalType,
    actions,
    listing = {}
  } = props

  const brandIdToggle = getFeatureToggle(flags, 'sp_brand2_fe')

  if (!brandIdToggle) {
    return null
  }

  return (
    <ProposalBlock className={styles.updateBrandIdBlock}>
      <BrandIDInfo
        listing={listing}
        proposalType={proposalType}
        triggerFieldChange={change}
        readOnly={readOnly}
        fetchBrands={actions.fetchBrands}
        flags={flags}
      />
    </ProposalBlock>
  )
}

export default UpdateBrandID
